// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--LYNQ2","content":"_0fce717cdb--content--aOcgk","text":"_0fce717cdb--text--tSMzM","image":"_0fce717cdb--image--mU7xS"};